module.exports = __webpack_public_path__ + "img/5.38ecee59.gif";